export const getters = {
  priceProfitability: ({ priceProfitability }) => priceProfitability,
  isPriceProfitabilityLoading: ({ isPriceProfitabilityLoading }) => isPriceProfitabilityLoading,
  boostedProductSet: (state) => state.boostedProductSet,
  boostedMenuProductSet: (state) => state.boostedMenuProductSet,
};
